import type { BoggleChallengeVowelRatioBand } from '~/boggle/config/challenges/modTypes'

export function assertValidBoggleChallengeVowelRatioBand(band: BoggleChallengeVowelRatioBand) {
  const { maxVowelRatioExclusive: max, minVowelRatio: min } = band
  if (!Number.isFinite(min) || !Number.isFinite(max)) {
    throw new Error(`Invalid vowel ratio band: min/max must be finite (got ${min}, ${max})`)
  }
  if (min < 0 || max > 1) {
    throw new Error(`Invalid vowel ratio band: expected min/max within [0, 1] (got ${min}, ${max})`)
  }
  if (!(min < max)) {
    throw new Error(
      `Invalid vowel ratio band: minVowelRatio must be < maxVowelRatioExclusive (got ${min}, ${max})`,
    )
  }
}
